import tr from './tr';
import en from './en';
import ar from './ar';

export type Language = 'tr' | 'en' | 'ar';

export const translations: Record<Language, Record<string, string>> = { tr, en, ar };

export const getTranslation = (lang: Language, key: string): string => {
  return translations[lang][key] || key;
};
